declare const posthog: any;
import FormDataWithToken from './form-data-with-token'
import { getCreditUnionGroups } from './posthog-group'

document.addEventListener('click', (event) => {
    // Carousel View
    let el1 = (event.target as HTMLElement).closest('.js-car-toggle-favourite-swiper')
    if (el1) {
        event.preventDefault();
        
        document.querySelector('.js-swiper-cars .swiper-slide-active .js-car-wrapper')?.classList.toggle('is-favourite');
        el1.classList.toggle('is-favourite');

        let activeSlide = document.querySelector('.js-car-item.swiper-slide-active')
        let isFav = activeSlide?.querySelector('.js-car-wrapper.is-favourite') != undefined
        let invId = document.querySelector('.js-car-item.swiper-slide-active')?.getAttribute('data-inventoryvehicleid')

        if (typeof posthog !== 'undefined') {
            posthog.capture(isFav ? 'vehicle_favorited' : 'vehicle_unfavorited', {
                vehicle_id: invId ?? undefined,
                $groups: getCreditUnionGroups(),
            });
        }

        const data = new FormDataWithToken()
        data.append('inventoryVehicleId', invId ?? '')
        data.append('like', String(isFav))

        fetch('?handler=SaveLikeDislike', { method: 'post', body: data })
    }

    // Grid View and other favorite buttons not in carousel view
    let el2 = (event.target as HTMLElement).closest('.js-car-toggle-favourite')
    if (el2) {
        event.preventDefault();

        el2.closest('.js-car-wrapper')?.classList.toggle('is-favourite');
        el2.classList.toggle('is-favourite');

        let invId = el2.closest('.js-car-item')?.getAttribute('data-inventoryvehicleid')
        let isFav = el2.closest('.js-car-wrapper.is-favourite') != undefined

        if (typeof posthog !== 'undefined') {
            posthog.capture(isFav ? 'vehicle_favorited' : 'vehicle_unfavorited', {
                vehicle_id: invId ?? undefined,
                $groups: getCreditUnionGroups(),
            });
        }

        const data = new FormDataWithToken()
        data.append('inventoryVehicleId', invId ?? '')
        data.append('like', String(isFav))

        fetch('/cars-for-sale/?handler=SaveLikeDislike', { method: 'post', body: data })
    }
})
